import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ParticlesBackground from './ParticlesBackground'; // Optional background component if needed
import api from "../axiosConfig";
import { useGuestPreview } from "../context/GuestPreviewContext";
import { setLoggedInUserEmail, clearLegacySearchSessionStorage } from "../utils/searchSessionStorage";

const PENDING_INIT_INTERESTS_KEY = "gradconnect_pending_init_interests";

const Registration = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        first_name: '',
        last_name: '',
    });
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const routerLocation = useLocation();
    const { clearGuestPreview } = useGuestPreview();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const response = await api.post('/register/', formData);

        if (response.status >= 200 && response.status < 300) { // Axios doesn't use `ok`, so check the status range
            const data = response.data;
            const researchInterests = routerLocation.state?.researchInterests || '';

            localStorage.setItem('authToken', data.access);
            localStorage.setItem('refreshToken', data.refresh);

            setLoggedInUserEmail(data.email);
            clearLegacySearchSessionStorage();

            clearGuestPreview();
            if (researchInterests) {
                sessionStorage.setItem(PENDING_INIT_INTERESTS_KEY, researchInterests);
            }

            navigate('/initialize-recommendations', {
                state: {
                    email: data.email,
                    researchInterests,
                },
            });
        }
    } catch (error) {
        const errorData = error.response?.data || {};
        // Check if the response contains error messages
        if (errorData.email) {
            setError(errorData.email[0]); // Display the email error message
        } else if (errorData.password) {
            setError(errorData.password[0]); // Display the password error message
        } else {
            setError('Registration failed. Please try again.');
        }
    }
};
    return (
        <div style={{ position: 'relative', minHeight: '100vh' }}>
            <ParticlesBackground /> {/* Add the Particles background */}
            <div className="flex items-center justify-center min-h-screen py-4 px-4">
                <form
                    onSubmit={handleSubmit}
                    className="bg-white p-10 rounded-lg shadow-lg w-full sm:w-96 md:w-3/5 lg:w-2/5 xl:w-1/3 max-w-lg mx-auto"  // Adjusted form width for larger breakpoints
                    style={{
                        backgroundColor: 'white',
                        zIndex: 1,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <h2 className="text-center text-3xl font-semibold text-[#202531] mb-6">
                        Create an Account
                    </h2>

                    {/* Error Message */}
                    {error && (
                        <div className="mb-4 text-center text-red-500">
                            <p>{error}</p>
                        </div>
                    )}

                    <div className="mb-6">
                        <label htmlFor="email" className="block text-[#202531] mb-2 text-left">
                            Email
                        </label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full p-4 border border-gray-300 rounded-md bg-[#F2F2F2]"
                            style={{
                                backgroundColor: '#F2F2F2',
                                borderColor: '#D1D5DB',
                                color: '#202531',
                            }}
                        />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="password" className="block text-[#202531] mb-2 text-left">
                            Password
                        </label>
                        <input
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Enter password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            className="w-full p-4 border border-gray-300 rounded-md bg-[#F2F2F2]"
                            style={{
                                backgroundColor: '#F2F2F2',
                                borderColor: '#D1D5DB',
                                color: '#202531',
                            }}
                        />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="first_name" className="block text-[#202531] mb-2 text-left">
                            First Name
                        </label>
                        <input
                            type="text"
                            name="first_name"
                            id="first_name"
                            placeholder="Enter first name"
                            value={formData.first_name}
                            onChange={handleChange}
                            required
                            className="w-full p-4 border border-gray-300 rounded-md bg-[#F2F2F2]"
                            style={{
                                backgroundColor: '#F2F2F2',
                                borderColor: '#D1D5DB',
                                color: '#202531',
                            }}
                        />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="last_name" className="block text-[#202531] mb-2 text-left">
                            Last Name
                        </label>
                        <input
                            type="text"
                            name="last_name"
                            id="last_name"
                            placeholder="Enter last name"
                            value={formData.last_name}
                            onChange={handleChange}
                            required
                            className="w-full p-4 border border-gray-300 rounded-md bg-[#F2F2F2]"
                            style={{
                                backgroundColor: '#F2F2F2',
                                borderColor: '#D1D5DB',
                                color: '#202531',
                            }}
                        />
                    </div>

                    <button
                        type="submit"
                        className="mt-2 bg-[#0196BF] text-white font-bold text-xl px-24 py-3 rounded-full hover:bg-[#017BA3] transition z-20 max-w-full mx-auto flex items-center justify-center"
                    >
                        Register
                    </button>

                    <div className="mt-4 text-center">
                        <p className="text-sm">
                            Already have an account?{' '}
                            <a
                                href="/login"
                                className="text-[#0196BF] hover:underline"
                            >
                                Login
                            </a>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Registration;
